export default {"src":"/bnb/_next/static/media/impossible.33812a14.svg","height":26,"width":22};